import page from "@/core/page"
import parsePrice from "./utils/price"
import { select, schemaFn, children } from "./utils/schema"
import { ConversionItem, WebsiteOrder } from "@/types"
import toInt from "./utils/toInt"
import text from "./utils/text"
import pipe from "@/utils/pipe"
import defaultValue from "./utils/defaultValue"
import defaultText from "./utils/defaultText"

const orderItemFn = schemaFn<ConversionItem>({
  product_id: select(".product_id"),
  sku_id: select(".sku_id"),
  name: select(".name"),
  quantity: select(".quantity", pipe(text, toInt)),
  unit_price: select(".unit_price", pipe(text, parsePrice)),
  price_currency_code: select(".price_currency_code")
})

const newsletterFn = (v: string | undefined) =>
  (v !== undefined ? String(["1", "true"].includes(v)) : undefined) as string

const orderFn = schemaFn<WebsiteOrder & { hcid: string }>({
  payment_provider: select(":scope > .payment_provider"),
  external_order_ref: select(":scope > .external_order_ref"),
  hcid: select(":scope > .hcid", pipe(text, defaultText("blank"))),
  order_status: select(":scope > .order_status_code"),
  info: schemaFn({
    order_number: select(":scope > .order_number"),
    type: select(":scope > .type", pipe(text, defaultValue("order"))),
    email: select(":scope > .buyer > .email"),
    first_name: select(":scope > .buyer > .first_name"),
    last_name: select(":scope > .buyer > .last_name"),
    country: select(":scope > .buyer > .country"),
    phone: select(":scope > .buyer > .phone"),
    post_code: select(":scope > .buyer > .post_code"),
    newsletter: select(":scope > .buyer > .marketing_permission", pipe(text, newsletterFn))
  }),
  items: children(".purchased_items .line_item", orderItemFn)
})

export default function findOrder() {
  const orderDiv = page.select(".nosto_purchase_order")
  if (!orderDiv) {
    return undefined
  }

  return orderFn(orderDiv) as WebsiteOrder
}
